<template>
    <ComCardExpand title="Hankkeet" :show="true" v-if="hankkeet" class="etusivu-hankkeet">
        <div class="float-right-flex">
            <el-checkbox label="Arkistoidut" v-model="arkistoidut" border data-test-id="etusivuArkistoidutCheckbox" />
        </div>
        <el-tree :data="hankkeet" :props="props">
            <template #default="{ data }">
                <div @click="hankeLink(data.id)" :class="{ 'arkistoitu-text': data.arkistoitu }">
                    <el-icon class="hanke-icon">
                        <DocumentCopy></DocumentCopy>
                    </el-icon>
                    <span>{{ data.nimi }}</span>
                </div>
            </template>
        </el-tree>
    </ComCardExpand>
    <ComCard v-else>
        <ComLoading />
    </ComCard>
</template>

<script setup lang="ts">
import ComCardExpand from "@/components/common/ComCardExpand.vue"
import ComLoading from "../common/ComLoading.vue"
import { DocumentCopy } from "@element-plus/icons-vue"
import router from "@/router"
import ComCard from "../common/ComCard.vue"
import { useHankkeet } from "@/methods/hankeComposables"
import { ElMessage } from "element-plus"

const { hankkeet, arkistoidut } = useHankkeet()
const props = {
    label: "nimi",
}
const hankeLink = (val: number) => {
    router.push({ name: "Hanke", params: { hankeId: val } })
}

const HUOLTOKATKO_LOPPU = new Date("2026-06-12T18:00:00").getTime()
const HUOLTOKATKO_AVAIN = "huoltokatko-12-6-2026-nahty"

if (Date.now() <= HUOLTOKATKO_LOPPU && !sessionStorage.getItem(HUOLTOKATKO_AVAIN)) {
    ElMessage.info({
        message: "Järjestelmä on huoltokatkolla 12.6.2026 klo 14:00-18:00. Tänä aikana palvelu ei ole käytettävissä.",
        showClose: true,
        duration: 0,
    })
    sessionStorage.setItem(HUOLTOKATKO_AVAIN, "1")
}

</script>
